import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { GooseLogo } from "@/components/common";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        // /auth/me carries the producer record the gate needs; the session response does not.
        await refresh();
        // Return to the entry the user signed in from — never route by role.
        const dest = window.location.pathname === "/admin" ? "/admin" : "/producer";
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(dest, { replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center goose-grain">
      <div className="relative z-10 text-center">
        <GooseLogo className="text-4xl" />
        <p className="mt-4 text-sm text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
